var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m331 376h60v60h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121 376h120v60h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 466c0 24.814 20.186 46 45 46h422c24.814 0 45-21.186 45-46v-316h-512zm421-15c0 8.291-6.709 15-15 15h-90c-8.291 0-15-6.709-15-15v-90c0-8.291 6.709-15 15-15h90c8.291 0 15 6.709 15 15zm-330-240c0-8.291 6.709-15 15-15h300c8.291 0 15 6.709 15 15v90c0 8.291-6.709 15-15 15h-300c-8.291 0-15-6.709-15-15zm0 150c0-8.291 6.709-15 15-15h150c8.291 0 15 6.709 15 15v90c0 8.291-6.709 15-15 15h-150c-8.291 0-15-6.709-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121 226h270v60h-270z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 0h-422c-24.814 0-45 20.186-45 45v75h512v-75c0-24.814-20.186-45-45-45zm-361 75c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15zm60 0c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15zm60 0c-8.284 0-15-6.716-15-15 0-8.286 6.716-15 15-15s15 6.714 15 15c0 8.284-6.716 15-15 15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.36f6640ab44fad7f6b696a366a5b46fe.svg";
export { ForwardRef as ReactComponent };